// 抖音黑料 · 单页首页演示数据（静态展示，仅供参考）
// 事件条目均为梳理排版的示例内容，用于页面完整性演示。

export const tickerItems: string[] = [
  "归档更新 · 直播带货争议系列新增 3 个关键节点",
  "当事人回应区已补充「声明全文」链接（第 12 章）",
  "本周新增 2 组图片时间线，支持前后对比",
  "话题墙新增标签：数据注水 / 抄袭调色盘",
  "网友讨论热评榜已完成本周排序",
  "原图与录屏素材已同步至归档资源区",
];

export const stats = [
  { value: "128", unit: "个", label: "在录专题" },
  { value: "946", unit: "条", label: "时间线节点" },
  { value: "37", unit: "份", label: "声明与回应" },
  { value: "60+", unit: "w", label: "累计浏览" },
  { value: "14", unit: "个", label: "资料归档包" },
];

export const quickEntries = [
  { icon: "ri-time-line", label: "进入全时间线", to: "#timeline" },
  { icon: "ri-download-2-line", label: "下载归档包", to: "#archive" },
  { icon: "ri-price-tag-3-line", label: "逛话题墙", to: "#topics" },
  { icon: "ri-chat-3-line", label: "看网友热评", to: "#discuss" },
];

// 最新短讯流
export const updateFeed = [
  { tag: "新增", tagColor: "bg-primary-100 text-primary-800", title: "「带货质量争议」新增验货环节节点", excerpt: "将当事人晒出的质检报告时间点并入主线，方便对照下单时间复盘。", time: "12 分钟前", hot: true },
  { tag: "回应", tagColor: "bg-accent-100 text-accent-800", title: "头部博主就抄袭质疑发长文说明", excerpt: "声明全文已收录至「当事人回应」区，评论区反向情绪与时间线一并归档。", time: "1 小时前", hot: true },
  { tag: "补图", tagColor: "bg-secondary-100 text-secondary-800", title: "两条对比素材已入库", excerpt: "图片时间线新增前后调色盘对照，可直接下拉查看差异细节。", time: "3 小时前", hot: false },
  { tag: "更新", tagColor: "bg-primary-100 text-primary-800", title: "数据注水专题补充平台侧说明", excerpt: "平台公告与处理结果按先后顺序接入主时间线，脉络更完整。", time: "昨天", hot: false },
  { tag: "新瓜", tagColor: "bg-accent-100 text-accent-800", title: "又一账号因刷量争议上热门", excerpt: "已开独立专题跟进，从首条爆料到账号回应按节点排列，随时可追。", time: "昨天", hot: false },
  { tag: "归档", tagColor: "bg-secondary-100 text-secondary-800", title: "第 12 章「前因后果」通稿完成", excerpt: "把零散聊天记录与评论区线索重新排序，想看始末直接读这一章。", time: "2 天前", hot: false },
];

// 主时间线 - 以某个代表型事件为示例骨架
export const timelinePhases = [
  {
    date: "发酵前夜",
    nodes: [
      { time: "首曝", title: "第一条爆料帖出现", desc: "匿名账号发出截图，指出某头部主播带货话术与实物不符，评论区开始有人跟帖补充线索。" },
      { time: "发酵", title: "截图与录屏开始在群内扩散", desc: "相关内容被二次搬运到多个社群，讨论从单品质量延伸到过往带货记录，话题热度快速爬升。" },
    ],
  },
  {
    date: "全面扩散",
    nodes: [
      { time: "热搜", title: "冲上平台热门与多平台热搜", desc: "相关词条进入搜索联想，大量二创与盘点视频出现，抖音黑料时间线开始被网友自行整理。" },
      { time: "对比", title: "前后素材对照帖流出", desc: "网友将直播片段与收到实物逐帧对比，形成第一版「打脸」整理帖，传播范围进一步扩大。" },
    ],
  },
  {
    date: "当事人回应",
    nodes: [
      { time: "声明", title: "当事人发布首份回应", desc: "以长文形式说明采购与质检流程，承认存在细节疏漏，但否认主观造假，引发两派解读。" },
      { time: "跟进", title: "平台侧处理结果公布", desc: "相关商品下架并启动复核，平台公告时间点已并入主线，脉络更清晰。" },
    ],
  },
  {
    date: "余波收束",
    nodes: [
      { time: "复盘", title: "博主发布道歉视频", desc: "针对态度问题再次道歉并给出补偿方案，评论区情绪趋缓，相关讨论热度逐步回落。" },
      { time: "归档", title: "事件进入档案库维护期", desc: "新增后续评论走向与博主近况备注，节点进入长期维护状态。" },
    ],
  },
];

// 当事人与相关方动态
export const responses = [
  { role: "当事人", tone: "bg-accent-100 text-accent-800", actor: "头部带货主播", status: "已发声明 + 道歉", time: "首曝后 2 天", text: "承认流程疏漏、否认主观造假，随后道歉并给出补偿方案，全文已收录。" },
  { role: "平台方", tone: "bg-secondary-100 text-secondary-800", actor: "短视频平台", status: "公告处理结果", time: "首曝后 3 天", text: "相关商品下架并复核，公布处理口径，已接入主线时间点。" },
  { role: "消费者", tone: "bg-primary-100 text-primary-800", actor: "下单用户", status: "补充验货证据", time: "持续进行", text: "晒出订单与收货时间线，为复盘提供一手素材，部分已录入资源库。" },
  { role: "创作者", tone: "bg-accent-100 text-accent-800", actor: "盘点型博主", status: "持续二创", time: "全程跟进", text: "多支盘点视频被网友引用，其梳理口径与本页时间线大体一致。" },
];

// 话题墙
export const topicGroups = [
  { name: "带货争议", color: "text-primary-700", tags: [["话术与实物不符", "31"], ["质检报告", "12"], ["售后避责", "9"], ["低价引流", "18"]] },
  { name: "抄袭对比", color: "text-accent-700", tags: [["调色盘对照", "22"], ["逐帧对比", "14"], ["二创搬运", "11"], ["原创声明", "8"]] },
  { name: "言论翻车", color: "text-primary-700", tags: [["评论区争议", "26"], ["直播口误", "17"], ["态度问题", "13"], ["回应翻车", "6"]] },
  { name: "数据注水", color: "text-secondary-700", tags: [["刷量质疑", "15"], ["投放争议", "10"], ["粉丝造假", "7"]] },
  { name: "平台处理", color: "text-accent-700", tags: [["限流", "19"], ["下架", "12"], ["官方通报", "9"], ["账号封禁", "5"]] },
];

// 归档资源
export const archives = [
  { title: "完整时间线 HTML 档案", type: "PDF / 网页", meta: "第 01–12 章 全节点", size: "2.4 MB", icon: "ri-file-text-line" },
  { title: "前因后果通稿 Markdown", type: "MD 文档", meta: "万字长文 修订 5 版", size: "860 KB", icon: "ri-markdown-line" },
  { title: "图片证据包", type: "ZIP 压缩包", meta: "原图 213 张 已脱敏", size: "148 MB", icon: "ri-file-image-line" },
  { title: "录屏素材整理", type: "ZIP 压缩包", meta: "12 段 关键片段", size: "512 MB", icon: "ri-film-line" },
  { title: "原始评论采集 CSV", type: "CSV 表格", meta: "清洗后 4.6w 条", size: "9.1 MB", icon: "ri-file-excel-2-line" },
  { title: "更新日志与维护说明", type: "TXT", meta: "归档维护记录", size: "38 KB", icon: "ri-file-list-3-line" },
];

// 网友热评
export const comments = [
  { author: "今天也在吃瓜", role: "资深记录员", tag: "实锤派", text: "最烦翻聊天记录拼瓜，这种按时间线捋的就舒服，前因后果一眼看完。", time: "2 小时前", like: "1284", hot: true },
  { author: "理性吃瓜人", role: "围观群众", tag: "中立", text: "回应区把当事人声明和平台公告都放一起最赞，省得两边来回跳。", time: "昨天", like: "963", hot: true },
  { author: "冲浪考古队", role: "资料党", tag: "收藏家", text: "图片时间线那版太好了，前后对比一目了然，已经收藏进我的档案夹。", time: "昨天", like: "711", hot: false },
  { author: "别打脸", role: "观察者", tag: "等后续", text: "等后续博主近况更新，这瓜还没完全收尾，先蹲一个。", time: "1 天前", like: "552", hot: false },
  { author: "吃瓜也要讲证据", role: "考据党", tag: "轻锤", text: "希望每条都能标一下信源程度，有些截图真伪还是要留个心眼。", time: "1 天前", like: "398", hot: false },
];

// FAQ
export const faqs = [
  { q: "什么是「抖音黑料时间线」？", a: "把某一热点抖音黑料从最开始发酵到当事人回应、再到平台处理的全过程，按发生顺序重新梳理成一条清晰脉络，避免只看到零散碎片。" },
  { q: "「前因后果」和普通盘点有什么区别？", a: "普通盘点偏情绪与表态，本页更侧重因果链：先有哪条线索、接着如何扩散、当事人哪一步回应、平台何时介入，全部按节点对号入座。" },
  { q: "为什么要按关键节点整理？", a: "吃瓜最怕顺序乱。按「首曝—发酵—扩散—回应—处理—余波」分层，能快速定位到想看的时间点，不用自己拼聊天记录。" },
  { q: "归档资源包能下载吗？", a: "页内展示的均为示意入口。正式归档包需在维护方授权渠道获取，网页只负责把内容结构与出处摆清楚。" },
  { q: "内容来源是否可靠？", a: "网页仅对公开讨论中的素材做顺序与结构整理，不生产、不坐实信息，请在阅读时自行交叉核对。" },
];